import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20with%20dramatic%20red%20curtains%20and%20spotlights%2C%20film%20projector%20beam%2C%20luxurious%20velvet%20seats%2C%20grand%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20elegant%20entertainment%20venue%2C%20high%20contrast%2C%20rich%20textures&width=1920&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <i className="ri-fire-line text-primary-400 text-sm"></i>
          <span className="text-xs md:text-sm text-primary-300 font-medium">每日更新 1000+ 热门视频</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight max-w-3xl">
          西瓜视频免费 · 91在线视频
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-200/80 max-w-2xl leading-relaxed">
          海量电影大全、电视剧全集、综艺节目高清播放不卡顿，免费在线观看体验
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/dianying"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/category/dianshiju"
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full text-sm border border-background-50/20 transition-all cursor-pointer whitespace-nowrap"
          >
            浏览电视剧
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-label">10万+</p>
            <p className="text-xs text-background-300/70 mt-1">视频资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/15"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-label">5000万+</p>
            <p className="text-xs text-background-300/70 mt-1">活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/15"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-label">99.9%</p>
            <p className="text-xs text-background-300/70 mt-1">播放流畅</p>
          </div>
        </div>
      </div>
    </section>
  );
}